import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import styles from './ButtonSimple.scss'

class ButtonSimple extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        isDisabled: PropTypes.bool,
        isContrast: PropTypes.bool,
        isExternal: PropTypes.bool,
        isGlow: PropTypes.bool,
        tooltipId: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        messages: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        className: PropTypes.string,
    }

    render() {
        const {
            isExternal,
            isGlow,
            isContrast,
            isDisabled,
            tooltipId,
            onClick,
            children,
            className,
        } = this.props

        const dataAttrs = tooltipId ? {
            'data-tip': true,
            'data-for': tooltipId,
        } : {}

        return (
            <div
                className={cx(styles.base, {
                    [styles.isExternal]: isExternal,
                    [styles.isGlow]: isGlow,
                    [styles.isContrast]: isContrast,
                    [styles.isDisabled]: isDisabled,
                }, className)}
                onClick={(e) => !isDisabled && onClick(e)}
                onMouseDown={(e) => !isDisabled && sendClickSoundCommand(e)}
                onMouseEnter={(e) => !isDisabled && sendHoverSoundCommand(e)}
                {...dataAttrs}
            >
                {children}
                {this.props.messages ? (
                    <div className={styles.messages}>
                        {this.props.messages > 99 ? '99+' : this.props.messages}
                    </div>
                ) : null}
            </div>
        )
    }
}

export default ButtonSimple



// WEBPACK FOOTER //
// ./components/ButtonSimple/ButtonSimple.jsx